import React from "react";
import { Route } from "react-router-dom";
import ModalDialog from "./elements/modal/ModalDialog";
import indepententService from "./independentService";
import Footer from "./independentService/Footer";
import Header from "./independentService/Header";

const IndependentServiceLayout = () => {
  return (
    <>
      <Header />
      <Route path="/" exact component={indepententService} />
      <Route path="/independent-service" exact component={indepententService} />
      <Footer />
      <ModalDialog />
    </>
  );
};

export default IndependentServiceLayout;
